import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FieldConfig } from 'src/app/shared/models/field-config.model';

@Component({
  selector: 'app-dialog-group-name-field',
  templateUrl: './dialog-group-name-field.component.html',
  styleUrls: ['./dialog-group-name-field.component.scss']
})
export class DialogGroupNameFieldComponent implements OnInit {

  public groupField: FormControl = new FormControl();

  constructor(
    public dialogRef: MatDialogRef<DialogGroupNameFieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dataGroupField: FieldConfig[] }
    ) {}

  ngOnInit() {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  groupNameField() {
    if(this.groupField.value) {
      this.dialogRef.close(this.groupField.value);
    }
  }
}
